import {
  Contract,
  ContractInterface,
  providers,
  BigNumber,
  utils,
} from 'ethers';

import MerkleDistributionSnapshotJson from './snapshot/10-merkle-distribution.json';
import MerkleDistributionAbiJson from './abis/merkleDistributor.json';

const merkleDistributionSnapshot: MerkleDistributionSnapshot = MerkleDistributionSnapshotJson;
const merkleDistributionAbi: ContractInterface = MerkleDistributionAbiJson;

const merkleDistributionAddress = '0xc227632FD02ae912AEB79dfbA916A16485c0be25';

function getAmount(
  address: string,
): string {
  if (merkleDistributionSnapshot.claims[address] === undefined) {
    return '0';
  }

  const amount = BigNumber.from(merkleDistributionSnapshot.claims[address].amount);

  return utils.formatEther(amount);
}

async function isClaimed(
  provider: providers.Web3Provider | providers.JsonRpcProvider,
  address: string,
): Promise<boolean> {
  console.log(provider);
  const contract = new Contract(merkleDistributionAddress, merkleDistributionAbi, provider);

  try {
    const res = await contract.isClaimed(merkleDistributionSnapshot.claims[address].index);
    return res;
  } catch (e) {
    console.log(e);
    throw new Error('Cannot check claim...');
  }
}

async function claim(
  provider: providers.Web3Provider | providers.JsonRpcProvider,
  address: string,
) {
  const contract = new Contract(
    merkleDistributionAddress,
    merkleDistributionAbi,
    provider.getSigner(),
  );

  try {
    const tx = await contract.claim(
      merkleDistributionSnapshot.claims[address].index,
      address,
      merkleDistributionSnapshot.claims[address].amount,
      merkleDistributionSnapshot.claims[address].proof,
    );

    const receipt = await tx.wait();
    return receipt;
  } catch (e) {
    console.log(e);
    throw new Error('Cannot claim...');
  }
}

async function fold(
  provider: providers.Web3Provider | providers.JsonRpcProvider,
) {
  const contract = new Contract(
    merkleDistributionAddress,
    merkleDistributionAbi,
    provider.getSigner(),
  );

  try {
    const tx = await contract.fold();
    const receipt = await tx.wait();
    return receipt;
  } catch (e) {
    console.log(e);
    throw new Error('Cannot fold...');
  }
}

export {
  getAmount,
  isClaimed,
  claim,
  fold,
};
